import { BaseService } from './base.service.js';
class UserQuestionService extends BaseService {
    async filter(dto) {
        return this.fetch('/user/question/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
    }
    async create(dto) {
        const { data } = await this.fetch('/user/question', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
        return data;
    }
    async update(dto) {
        const { data } = await this.fetch('/user/question', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
        return data;
    }
    async remove(id) {
        const { data } = await this.fetch(`/user/question/${id}`, {
            method: 'DELETE',
        });
        return data;
    }
}
export const userQuestionService = new UserQuestionService();
